module.exports = __webpack_public_path__ + "static/media/step1.caae3c2d.svg";